import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor() {
    console.log('GlobalErrorHandler initialized and ready to catch errors');
  }

  handleError(error: Error | any): void {
    console.group('🚨 Global Error Handler');
    console.error('Error caught:', error);

    // Log the error message
    if (error?.message) {
      console.error('Message:', error.message);
    }

    // Log additional details if available
    if (error?.stack) {
      console.error('Stack trace:', error.stack);
    }

    // Log HTTP error details if it's an HTTP error
    if (error?.status) {
      console.error('HTTP Status:', error.status);
      console.error('HTTP Error:', error.error);
    }

    // Log any additional properties
    console.error('Full error object:', error);
    console.groupEnd();

    // You can add additional logic here such as:
    // - Sending errors to a logging service
    // - Showing user-friendly error messages
    // - Filtering out specific errors
  }
}